import { render, staticRenderFns } from "./Fishcatchtradesearch.vue?vue&type=template&id=0f7cd0e5&"
import script from "./Fishcatchtradesearch.vue?vue&type=script&lang=js&"
export * from "./Fishcatchtradesearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports